/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import fileSaver from 'file-saver';
import moment from 'moment';
import JSZip from 'jszip';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { API, ERR } from '@config/common';
import Utils from '@action/util';
import api from '@api/index';
import EventBus from '@utils/bus';
import { IVideoState } from '@typings';

export const convertArrayBufferToBase64 = (data) => {
  const bytes = new Uint8Array(data);
  const len = bytes.byteLength;
  let binary = '';

  for (let i = 0; i < len; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

const startCheckEncodingJobState = (jobId, jobType) => {
  state.job_id = jobId;
  state.job_type = jobType;
  state.job_checker_id = setInterval(encodingJobStateCallback, 1000);
};

const encodingJobStateCallback = () => {
  actions.ENCODING_STATE(state.job_id);
};

const updateJobStateLoading = (states) => {
  switch (states) {
    case 'waiting':
      if (!state.job_state_waiting) {
        state.job_state_waiting = true;
      }
      break;

    case 'inprogress':
      if (state.job_state_waiting) {
        state.job_state_waiting = false;
      }
      if (!state.job_state_inprogress) {
        state.job_state_inprogress = true;
      }
      break;

    default:
      if (state.job_state_waiting || state.job_state_inprogress) {
        state.job_state_waiting = false;
        state.job_state_inprogress = false;
      }
      break;
  }
};

export const state: IVideoState = {
  deviceType: '',
  img_list: {},
  fileName: '',
  size: null,
  reg_date: moment().format('YYYY.MM.DD hh:mm'),
  step_type: '',
  fileData: new Blob(),
  product_type_id: '',
  production_per: 0,
  job_id: '',
  job_checker_id: 0,
  job_state: '',
  job_type: '', // capture_user, capture_theme, encode
  job_state_waiting: false,
  job_state_inprogress: false,
  job_theme_cb: () => undefined,
};

const getters = {
  encodingState(state) {
    return state.job_state;
  },
};

const mutations = {
  SET_JOB_STATE(payload) {
    state.job_state = payload;
  },
};

const actions = {
  FILE_UPLOAD(_, formData) {
    state.fileData = formData.get('file');
    state.product_type_id = formData.get('product_type_id');
    state.step_type =
      formData.get('url') === API.CONVERT_VIDEO ? 'upload-effect' : 'upload';

    return api.video
      .fileUpload(formData)
      .then(({ data }) => {
        if (data.code === API.ERR_REQ_SUCCESS) {
          startCheckEncodingJobState(data.items.job_id, 'capture_user');
        }
      })
      .catch(({ response }) => {
        const { code } = response.data;
        if (code === ERR.CONTS_DURATION_TOO_SHORT) {
          alert(eve.Lang.t('mov_making.convert_minimum_time', { time: 15 }));
        } else if (code === ERR.CONTS_EMPTY_FILE) {
          alert(eve.Lang.t('common.d_size_mov_error'));
        }
        EventBus.$emit('is-opend');
      });
  },

  async VIDEO_MAKING(_, formData) {
    try {
      const { data } = await api.video.videoMaking(formData);
      startCheckEncodingJobState(data.items.job_id, 'encode');
    } catch ({ response }) {
      const { code } = response.data;
      if (
        code === ERR.CONTS_EMPTY_FILE ||
        code === ERR.COMM_INVALID_REQUEST_PARAM
      ) {
        alert(eve.Lang.t('common.d_size_mov_error'));
      } else if (code === ERR.CONTS_ENCODING_SVR) {
        alert(eve.Lang.t('common.d_encoding_server_error'));
      } else {
        alert(eve.Lang.t('common.d_fail_upload'));
      }
      EventBus.$emit('is-opend');
    }
  },

  CONVERT_ONLY_IMAGE(_, formData) {
    return api.video
      .pictureToVideo(formData)
      .then(({ data }) => {
        if (data.code === Common.CODE_OK) {
          startCheckEncodingJobState(data.items.job_id, 'encode');
        }
      })
      .catch((err) => {
        const { code } = err.response.data;
        if (code === ERR.CONTS_EMPTY_FILE) {
          alert(eve.Lang.t('common.d_size_mov_error'));
        } else if (code === ERR.SOURCE_VIDEO_FILE_WRITE_FAIL) {
          alert(eve.Lang.t('common.d_mov_write_error'));
        } else if (code === ERR.CONTS_ENCODING_SVR) {
          alert(eve.Lang.t('common.d_encoding_server_error'));
        }
        EventBus.$emit('is-opend');
        EventBus.$emit('move-back');
      });
  },

  ENCODING_STATE: async (data) => {
    if (window.location.pathname !== '/video') {
      clearInterval(state.job_checker_id);
      EventBus.$emit('move-back');
      return;
    }

    const res = await api.video.encodingState(data);

    if (res.data.code === API.ERR_REQ_SUCCESS) {
      mutations.SET_JOB_STATE(res.data.items.state);
      updateJobStateLoading(res.data.items.state);
      if (res.data.items.state === 'finished') {
        clearInterval(state.job_checker_id);
        state.job_checker_id = 0;
        switch (state.job_type) {
          case 'capture_user':
            // 동영상 문구 삽입하여 제작하기
            actions.USER_CAPTURE_DOWNLOAD(state.job_id);
            break;
          case 'capture_theme':
            // 테마 사용하여 제작하기
            actions.THEME_CAPTURE_DOWNLOAD(state.job_id);
            break;
          case 'encode':
            // 인코딩 완료
            alert(eve.Lang.t('common.t_msg_complete'));
            EventBus.$emit('is-opend', 'state_encode');
            break;
          default:
            break;
        }
      } else if (res.data.items.state === 'failed') {
        clearInterval(state.job_checker_id);
        state.job_checker_id = 0;
        alert(eve.Lang.t('common.d_encoding_server_error'));
        EventBus.$emit('is-opend');
        EventBus.$emit('move-back');
      }
    } else {
      updateJobStateLoading('failed');
      clearInterval(state.job_checker_id);
      state.job_checker_id = 0;
      alert(eve.Lang.t('common.d_encoding_server_error'));
      EventBus.$emit('move-back');
      EventBus.$emit('is-opend');
    }
  },

  VIDEO_DOWNLOAD(_, obj) {
    if (sessionStorage.getItem('access_type') === 'web') {
      EventBus.$emit('spinner-open');
      return api.video
        .videoDownload(obj.jobId)
        .then((res) => {
          const zip = new JSZip();

          zip.loadAsync(res.data).then((zipData) => {
            zipData.forEach((relativePath, zipEntry) => {
              const fileNameArr = zipEntry.name.split('.').length;
              const fileName = zipEntry.name.split('.')[0];
              const fileType = zipEntry.name.split('.')[1];
              const fileCheckSum = zipEntry.name.split('.')[2];

              if (fileNameArr === 2) {
                zip.file(`${fileName}.${fileType}`, (zipEntry as any)._data);
              } else {
                zip.file(
                  `${fileName}.${fileType}.${fileCheckSum}`,
                  (zipEntry as any)._data,
                );
              }
            });
            zip.generateAsync({ type: 'blob' }).then((content) => {
              fileSaver(content, obj.data);
              EventBus.$emit('is-opend');
              window.location.href = '/';
            });
          });
        })
        .catch((err) => {
          alert(eve.Lang.t('user.server_error'));
          EventBus.$emit('is-opend');
          Utils.exceptHandler(err);
        });
    }

    // 유저에이전트를 불러와서 OS를 구분합니다.
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.search('android') > -1) {
      EventBus.$emit('spinner-open');
    }

    return api.video
      .webViewVideoDownload(obj.jobId)
      .then((res) => {
        if (userAgent.search('android') > -1) {
          globalThis.HybridAppBridge.runMethod(
            'goHome',
            res.data.items.file,
            obj.data,
          );
        } else if (
          userAgent.search('iphone') > -1 ||
          userAgent.search('ipod') > -1 ||
          userAgent.search('ipad') > -1 ||
          userAgent.search('ios') > -1
        ) {
          // eslint-disable-next-line no-undef
          globalThis.webkit.messageHandlers.runMethod.postMessage({
            actions: 'goHome',
            url: res.data.items.file,
            fileN: obj.data,
          });
        } else {
          alert('error: userAgent not found');
        }
      })
      .catch((err) => {
        Utils.exceptHandler(err);
      });
  },

  USER_CAPTURE_DOWNLOAD: (jobId) => {
    return api.video
      .captureFileDownload(jobId)
      .then((res) => {
        const zip = new JSZip();
        let cnt = 0;

        const formData = new FormData();
        formData.append('product_type_id', state.product_type_id);
        formData.append('file', state.fileData);

        zip
          .loadAsync(res.data)
          .then((zipData) => {
            zipData.forEach((relativePath, zipEntry) => {
              // eslint-disable-next-line consistent-return
              zipEntry.async('arraybuffer').then((content) => {
                cnt += 1;
                const fileExt = _.toLower(Utils.getFileExtension(relativePath));
                let trimmedFile;

                if (_.includes(['avi', 'mp4', 'mov'], fileExt)) {
                  const videoFilename = relativePath;
                  const blobContent = new Blob([content]);
                  trimmedFile = new File([blobContent], videoFilename);
                } else {
                  api.video.default.data.img_list[
                    `video${relativePath}`
                  ] = `data:image/jpg;base64,${convertArrayBufferToBase64(
                    content,
                  )}`;
                }

                if (cnt === Object.keys(zipData.files).length) {
                  if (
                    trimmedFile === undefined ||
                    trimmedFile.name === undefined
                  ) {
                    alert(eve.Lang.t('common.msg_mov_err'));
                    EventBus.$emit('is-opend', 'big_mov_upload_fail');
                    return 0;
                  }
                  EventBus.$emit('childs-event', {
                    type: Common.EVT_CB_SCREEN_TYPE,
                    screen_type: 'effect',
                    data: {
                      product_type_id: formData.get('product_type_id'),
                      img_list: api.video.default.data.img_list,
                      file_name: trimmedFile.name,
                      size: `${Utils.byteToMb(trimmedFile.size)}MB`,
                      reg_date: moment().format('YYYY.MM.DD hh:mm'),
                      step_type: state.step_type,
                      file_data: trimmedFile,
                    },
                  });
                }
              });
            });
          })
          .catch((err) => {
            alert(eve.Lang.t('common.msg_mov_err'));
            EventBus.$emit('is-opend', 'big_mov_upload_fail');
            Utils.exceptHandler(err);
          });
      })
      .catch((err) => {
        alert(eve.Lang.t('user.server_error'));
        EventBus.$emit('is-opend');
        Utils.exceptHandler(err);
      });
  },

  THEME_CAPTURE_DOWNLOAD: (jobId) => {
    return api.video
      .captureFileDownload(jobId)
      .then((res) => {
        state.job_theme_cb(res);
      })
      .catch((err) => {
        alert(eve.Lang.t('user.server_error'));
        EventBus.$emit('is-opend');
        Utils.exceptHandler(err);
      });
  },

  /*
   * 테마 관련
   */
  API_THEME(_, obj) {
    return api.video
      .themeView(obj.data)
      .then((res) => {
        obj.cb(res.data);
      })
      .catch((err) => {
        alert(eve.Lang.t('user.server_error'));
        EventBus.$emit('is-opend');
        Utils.exceptHandler(err);
      });
  },

  THEME_VIEW_THUMBNAIL(_, obj) {
    return api.video
      .themeViewThumbnail(obj.content_id)
      .then((res) => {
        obj.cb(res, obj);
      })
      .catch((err) => {
        alert(eve.Lang.t('user.server_error'));
        EventBus.$emit('is-opend');
        Utils.exceptHandler(err);
      });
  },

  IMG_SERVER_REQUEST(_, obj) {
    state.job_theme_cb = obj.cb;
    return api.video
      .imgServerRequest(obj.data, obj.user_id ? obj.user_id : undefined)
      .then((res) => {
        if (res.data.code === API.ERR_REQ_SUCCESS) {
          startCheckEncodingJobState(res.data.items.job_id, 'capture_theme');
        } else {
          alert(eve.Lang.t('common.d_fail_upload'));
        }
      })
      .catch(({ response }) => {
        const { code } = response.data;
        if (code === ERR.CONTS_DURATION_TOO_SHORT) {
          alert(eve.Lang.t('mov_making.convert_minimum_time', { time: 15 }));
        } else {
          alert(eve.Lang.t('common.d_fail_upload'));
        }
        EventBus.$emit('is-opend');
      });
  },

  CATEGORY_SELECT() {
    return api.video.categorySelect();
  },

  THEME_INFO(_, themeId) {
    return api.video.themeInfo(themeId);
  },

  THEME_PREVIEW(_, themeId) {
    return api.video.themePreview(themeId);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
